import CryptoJS from 'crypto-js'

/**
 * ВНИМАНИЕ: password приходит из REACT_APP_SECRET_PASSWORD, а все REACT_APP_*
 * инлайнятся в бандл при сборке. Ключ лежит в том же JS, что и шифротекст,
 * поэтому это обфускация, а не защита — от XSS не спасает.
 *
 * Сигнатуры обещали string, но обе функции возвращали null в catch.
 */
export const encryptToken = (
  token?: string | null,
  password?: string | null
): string | null => {
  if (!token || !password) return null

  try {
    return CryptoJS.AES.encrypt(token, password).toString()
  } catch {
    return null
  }
}

export const decryptToken = (
  encrypted?: string | null,
  password?: string | null
): string | null => {
  if (!encrypted || !password) return null

  try {
    // При неверном ключе toString(Utf8) либо бросает, либо отдаёт пустую строку.
    return CryptoJS.AES.decrypt(encrypted, password).toString(CryptoJS.enc.Utf8) || null
  } catch {
    return null
  }
}
